<template>
  <div class="vue-contentido">
    <iframe width="100%" height="800" :src="ruta" frameborder="0" allowfullscreen></iframe>
  </div>
</template>      
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {     
      panel: null
      ,ruta:null
    };
  },
  computed: {
    ...mapGetters(["gcontenido"])
  },
  methods: {
    ...mapActions(["textosTodos"]),  
     usuario() {
      return JSON.parse(unescape(localStorage.usuario));
    },        
  },

  created() {
    this.textosTodos();
    let ruta2 = this.$route.params.ruta;
    let global = JSON.parse(unescape(process.env.PACKAGE_JSON)).global;
    let env = global[global.env];
    this.$aes.setKey(env.path.secret);
    let temporal = ruta2.replace(/AbcYq/g, "/");
    temporal = temporal.replace(/qYcbA/g, "+");
    temporal = this.$aes.decrypt(temporal);
    console.log('temporal', temporal)
    this.ruta= temporal + "?token=" + this.usuario().token;
  }
  ,
  watch:
  {
   
  }
};
</script>